// Deterministic colored-avatar palette (Gmail/Slack-style — same name/email
// always gets the same color) shared between EmailOverview.js's thread list
// and EmailThread.js's message cards, so a contact reads as the same person
// in both places.
const AVATAR_PALETTE = ['#f97316', '#eab308', '#22c55e', '#14b8a6', '#0ea5e9', '#6366f1', '#a855f7', '#ec4899', '#ef4444'];

export const avatarColor = (seed) => {
  const source = (seed || '').trim().toLowerCase();
  if (!source) return AVATAR_PALETTE[0];
  let hash = 0;
  for (let i = 0; i < source.length; i += 1) hash = (hash * 31 + source.charCodeAt(i)) >>> 0;
  return AVATAR_PALETTE[hash % AVATAR_PALETTE.length];
};

export const avatarInitials = (name, fallback) => {
  const source = (name || fallback || '').trim();
  if (!source) return '?';
  const parts = source.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return source.slice(0, 2).toUpperCase();
};

// Shared by every attachment chip (EmailThread.js's composer/messages,
// EmailMailbox.js's reading pane).
export const formatFileSize = (bytes) => {
  if (!bytes && bytes !== 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
